// 9fbef606107a605d69c0edbcd8029e5d
import WRITE_REVIEW_CONSTANTS from '../WriteReview.constants';

export const setWriteReviewModalOpen = (payload) => {
  return {
    type: WRITE_REVIEW_CONSTANTS.SET_WRITE_REVIEW_MODAL_MOUNTED_STATE,
    payload,
  };
};

export const setAddPhotoModalOpen = (payload) => {
  return {
    type: WRITE_REVIEW_CONSTANTS.SET_ADD_PHOTO_MODAL_MOUNTED_STATE,
    payload,
  };
};

export const setAddVideoModalOpen = (payload) => {
  return {
    type: WRITE_REVIEW_CONSTANTS.SET_ADD_VIDEO_MODAL_MOUNTED_STATE,
    payload,
  };
};

export const setSubmissionFeedbackModalOpen = (payload) => {
  return {
    type: WRITE_REVIEW_CONSTANTS.SET_SUBMISSION_FEEDBACK_MODAL_MOUNTED_STATE,
    payload,
  };
};

export const setProductDataForReview = (payload) => {
  return {
    type: WRITE_REVIEW_CONSTANTS.SET_WRITE_REVIEW_PRODUCT_DATA,
    payload,
  };
};

export const setAddPhotoData = (payload) => {
  return {
    type: WRITE_REVIEW_CONSTANTS.SET_WRITE_REVIEW_ADD_PHOTO_DATA,
    payload,
  };
};

export const setAddVideoData = (payload) => {
  return {
    type: WRITE_REVIEW_CONSTANTS.SET_WRITE_REVIEW_ADD_VIDEO_DATA,
    payload,
  };
};

export const setAddPhotoModalInitialData = (payload) => {
  return {
    type: WRITE_REVIEW_CONSTANTS.SET_WRITE_REVIEW_ADD_PHOTO_MODAL_INITIAL_DATA,
    payload,
  };
};

export const setAddVideoModalInitialData = (payload) => {
  return {
    type: WRITE_REVIEW_CONSTANTS.SET_WRITE_REVIEW_ADD_VIDEO_MODAL_INITIAL_DATA,
    payload,
  };
};

export const removeRateAndReviewUnique = (payload) => {
  return {
    type: WRITE_REVIEW_CONSTANTS.REMOVE_RATE_AND_REVIEW_ID,
    payload,
  };
};
